// src/pages/SuperAdmin/Venues/venuesApi.js
import api from "../../../components/axiosComp";
import axios from "axios"; 

// --- S3 upload helpers (direct-to-S3) ---

export const presignUpload = async ({ folder, filename, contentType }) => {
  try {
        console.log("[FE_PRESIGN] sending", { folder, filename, contentType, origin: window.location.origin });

    const { data } = await api.post("/api/uploads/presign", {
      folder,
      filename,
      contentType,
    });
        console.log("[FE_PRESIGN] received", data);

    return data;
  } catch (err) {
    console.error("[PRESIGN] failed:", err);
    console.error("[PRESIGN] message:", err?.message);
    console.error("[PRESIGN] status:", err?.response?.status);
    console.error("[PRESIGN] data:", err?.response?.data);
    throw err;
  }
};



export const uploadFileToS3 = async ({ presign, file, onProgress }) => {
  try {
    const s3Client = axios.create();
        console.log("[FE_S3PUT] start", {
      uploadUrlHost: (() => { try { return new URL(presign.uploadUrl).host; } catch { return "bad-url"; } })(),
      fileType: file?.type,
      fileSize: file?.size,
      filePath: presign.filePath,
    });

    const resp = await s3Client.put(presign.uploadUrl, file, {
      headers: { "Content-Type": file.type },
      onUploadProgress: (evt) => {
        if (onProgress && evt.total) {
          onProgress(Math.round((evt.loaded / evt.total) * 100));
        }
      },
    });
        console.log("[FE_S3PUT] done", { status: resp?.status, filePath: presign.filePath });


    if (![200, 201, 204].includes(resp?.status)) {
      throw new Error("S3 upload failed");
    }

    return { filePath: presign.filePath };
  } catch (err) {
    console.error("[S3PUT] failed:", err);
    console.error("[S3PUT] message:", err?.message);
    console.error("[S3PUT] status:", err?.response?.status);
    console.error("[S3PUT] data:", err?.response?.data);
    throw err;
  }
};



/**
 * READ (list)
 * Works with either {items,total,page,pageSize} or a raw array from the backend.
 */
export async function listVenues(params = {}) {
  const { page = 1, pageSize = 50, q = "" } = params;
  const { data } = await api.get("/api/superAdmin/venues", {
    params: { page, pageSize, q },
  });

  const items = Array.isArray(data?.items)
    ? data.items
    : Array.isArray(data)
      ? data
      : [];

  return {
    items,
    total: data?.total ?? items.length,
    page: data?.page ?? page,
    pageSize: data?.pageSize ?? pageSize,
  };
}

/**
 * READ (single, admin-protected)
 */
export async function getVenue(id) {
  const { data } = await api.get(`/api/superAdmin/venues/${id}`);
  // normalize to always return the doc
  return data?.venue ?? data;
}

/**
 * READ (public by slug OR id) — not protected
 * Useful later for a public preview; safe to keep here.
 */
export async function getVenuePublic(slugOrId) {
  const { data } = await api.get(`/api/venues/${slugOrId}`);
  return data?.venue ?? data;
}

/**
 * CREATE
 * Returns the created document (normalized).
 */
export async function createVenue(payload) {
    console.log("[FE_CREATE_VENUE] payload.media", payload?.media);

  const { data } = await api.post("/api/superAdmin/venues", payload);
    console.log("[FE_CREATE_VENUE] response.venue.media", (data?.venue ?? data)?.media);

  // backend may return {venue, message} or the doc directly
  return data?.venue ?? data;
}

/**
 * UPDATE (full)
 * Returns the updated document (normalized).
 */
export async function updateVenue(id, payload) {
    console.log("[FE_UPDATE_VENUE] payload.media", payload?.media);

  const { data } = await api.put(`/api/superAdmin/venues/${id}`, payload);
    console.log("[FE_UPDATE_VENUE] response.venue.media", (data?.venue ?? data)?.media);

  return data?.venue ?? data;
}

/**
 * TOGGLE STATUS (active/inactive)
 * Returns the updated document (normalized).
 */
export async function toggleVenueStatus(id, active) {
  const { data } = await api.patch(`/api/superAdmin/venues/${id}/status`, {
    active,
  });
  return data?.venue ?? data;
}

/**
 * DELETE (soft delete on server)
 * Normalizes to a small success shape.
 */
export async function deleteVenue(id) {
  const { data } = await api.delete(`/api/superAdmin/venues/${id}`);
  // accept either {ok:true} / {message:"..."} / deleted doc
  return {
    ok: data?.ok ?? true,
    message: data?.message ?? "Deleted",
    venue: data?.venue, // if server sends it
  };
}

export async function getVenueById(id) {
  const { data } = await api.get(`/api/superAdmin/venues/${id}`);
  return data;
}
